export const financialCommandPath = {
  conversionConfirm: "/conversions/confirm",
  redemptionConfirm: "/redemptions/confirm",
  redemptionPrepare: "/redemptions/prepare",
  redemptionResend: "/redemptions/:id/resend",
} as const

export type FinancialAction = {
  readonly kind: "conversion.confirm" | "redemption.confirm" | "redemption.prepare" | "redemption.resend"
  readonly resourceId: string
}

export const financialActionKey = (action: FinancialAction): string => `web-${action.kind.replaceAll(".", "-")}-${action.resourceId}`
